import styled from "styled-components";
import { Card } from "../../ui";
export const StyledCard = styled(Card) `
  border: 1px solid #F3F3F3;
`;
export const ToggleCardTitle = styled.span `
  font-size: 1.125rem;
  font-weight: 700;
  user-select: none;
`;
